// Real brand logo (transparent PNG in /public). Same asset for all slots.
const LOGO_SRC = "/logo.png";

export const LOGO = {
    nav: LOGO_SRC,
    hero: LOGO_SRC,
    footer: LOGO_SRC,
};

export const WHATSAPP = "https://wa.me/34987920859";
export const PHONE = "tel:+34987920859";
export const INSTAGRAM = "https://www.instagram.com/quefresas.es/";
export const MAPS_EMBED =
    "https://www.google.com/maps?q=Plaza+Cortes+Leonesas+Le%C3%B3n+Spain&output=embed";

export const CATEGORIES = [
    { id: "fresas-crema", label: "Fresas con Crema" },
    { id: "fresas-helado", label: "Fresas con Helado" },
    { id: "gofres-crema", label: "Gofres Bubble Crema" },
    { id: "gofres-helado", label: "Gofres Bubble Helado" },
    { id: "smoothies", label: "Smoothies" },
];

export const MENU = {
    "fresas-crema": {
        note: "Todos incluyen 1 salsa y 1 topping",
        items: [
            {
                name: "ANTOJO",
                emoji: "🍓",
                desc: "Ideal para darte un capricho",
                price: "3,90€",
                image: "/menu/fc_antojo.png",
            },
            {
                name: "CAPRICHO",
                emoji: "🍓🍓",
                desc: "El equilibrio perfecto",
                price: "5,40€",
                image: "/menu/fc_capricho.png",
            },
            {
                name: "QUEFRESA!",
                emoji: "👑",
                desc: "Para los que quieren lo máximo",
                price: "6,90€",
                image: "/menu/fc_quefresa.png",
            },
        ],
    },
    "fresas-helado": {
        note: "Elige tu helado: Fresa o Vainilla 🍦",
        items: [
            {
                name: "ANTOJO",
                emoji: "🍓",
                desc: "Ideal para darte un capricho",
                meta: "270 ml · 1 salsa + 1 topping clásico",
                price: "5,90€",
                image: "/menu/fh_antojo.png",
            },
            {
                name: "CAPRICHO",
                emoji: "🍓🍓",
                desc: "El equilibrio perfecto",
                meta: "360 ml · 1 salsa + 1 topping clásico + 1 sirope",
                price: "7,90€",
                image: "/menu/fh_capricho.png",
            },
            {
                name: "QUEFRESA!",
                emoji: "👑",
                desc: "Para los que quieren lo máximo",
                meta: "480 ml · 1 salsa + 2 toppings (clásicos o premium)",
                price: "9,40€",
                image: "/menu/fh_quefresa.png",
            },
        ],
    },
    "gofres-crema": {
        items: [
            {
                name: "FRESA LOVER",
                emoji: "🍓",
                desc: "Fresa + crema",
                price: "3,90€",
                image: "/menu/gc_fresa.png",
            },
            {
                name: "BANANA LOVER",
                emoji: "🍌",
                desc: "Crema + fresas + banana + 1 salsa",
                price: "5,40€",
                image: "/menu/gc_banana.png",
            },
            {
                name: "CAPRICHO LOVER",
                emoji: "✨",
                desc: "Crema + fresas + 1 fruta (a elección) + 1 salsa + 1 topping",
                price: "6,40€",
                image: "/menu/gc_capricho.png",
            },
            {
                name: "QUEFRESA! LOVER",
                emoji: "👑",
                desc: "Crema + fresas + 2 frutas (a elección) + 1 salsa + 1 topping + 1 sirope",
                price: "7,90€",
                image: "/menu/gc_quefresa.png",
            },
        ],
    },
    "gofres-helado": {
        note: "Elige tu helado: Fresa o Vainilla 🍦",
        items: [
            {
                name: "FRESA LOVER",
                emoji: "🍓",
                desc: "Helado + fresas",
                price: "5,90€",
                image: "/menu/gh_fresa.png",
            },
            {
                name: "BANANA LOVER",
                emoji: "🍌",
                desc: "Helado + fresas + banana + 1 salsa",
                price: "7,40€",
                image: "/menu/gh_banana.png",
            },
            {
                name: "CAPRICHO LOVER",
                emoji: "✨",
                desc: "Helado + fresas + 1 fruta (a elección) + 1 salsa + 1 topping",
                price: "8,40€",
                image: "/menu/gh_capricho.png",
            },
            {
                name: "QUEFRESA!",
                emoji: "👑",
                desc: "Helado + fresas + 2 frutas (a elección) + 1 salsa + 1 topping + 1 sirope",
                price: "9,90€",
                image: "/menu/gh_quefresa.png",
            },
        ],
    },
    smoothies: {
        badge: "100% Fruta Natural · 500 ml 🥤",
        price: "Todos a 4,90€",
        items: [
            {
                name: "FRESA LOVER",
                desc: "Fresa + Fresa",
                price: "4,90€",
                image: "/menu/s1_fresa.png",
            },
            {
                name: "BANANA LOVER",
                desc: "Fresa + Banana",
                price: "4,90€",
                image: "/menu/s2_banana.png",
            },
            {
                name: "TROPICAL",
                desc: "Mango + Piña",
                price: "4,90€",
                image: "/menu/s3_tropical.png",
            },
            {
                name: "FRUTOS ROJOS",
                desc: "Fresa + Arándanos",
                price: "4,90€",
                image: "/menu/s4_frutosrojos.png",
            },
            {
                name: "DELICIOS",
                desc: "Fresa + Durazno",
                price: "4,90€",
                image: "/menu/s5_delicios.png",
            },
            {
                name: "FULL ENERGÍA",
                desc: "Melocotón + Mango + Uva verde",
                price: "4,90€",
                image: "/menu/s6_fullenergia.png",
            },
            {
                name: "VERANO LOVER",
                desc: "Melocotón + Mango + Piña",
                price: "4,90€",
                image: "/menu/s7_verano.png",
            },
            {
                name: "PARAÍSO",
                desc: "Mango + Piña + Plátano",
                price: "4,90€",
                image: "/menu/s8_paraiso.png",
            },
            {
                name: "FRESA TROPICAL",
                desc: "Fresa + Piña + Mango",
                price: "4,90€",
                image: "/menu/s9_fresatropical.png",
            },
            {
                name: "DORADO TROPICAL",
                desc: "Plátano + Melocotón + Piña",
                price: "4,90€",
                image: "/menu/s10_dorado.png",
            },
        ],
    },
};

export const EXTRAS = [
    { label: "Salsas", price: "+1,00€" },
    { label: "Toppings Clásicos", price: "+0,80€" },
    { label: "Toppings Premium", price: "+1,00€" },
    { label: "Frutas Extra", price: "+1,00€" },
    { label: "Siropes", price: "+0,70€" },
    { label: "Nata Adicional", price: "+1,00€" },
];

export const FEATURES = [
    {
        icon: "🍓",
        title: "Fresas Frescas del Día",
        desc: "Solo usamos fresas seleccionadas, jugosas y naturales",
    },
    {
        icon: "🎨",
        title: "Tú Personalizas",
        desc: "Elige tus toppings y salsas favoritas, nosotros hacemos la magia",
    },
    {
        icon: "⭐",
        title: "5 Estrellas en Google",
        desc: "Valoración perfecta. Nuestros clientes lo dicen todo",
    },
];

export const REVIEWS = [
    {
        name: "Joseph Urquia",
        text: "Todo muy delicioso, los batidos son muy variados, me encantó el de fresas con arándanos Berries Cream",
    },
    {
        name: "Deisy Lopez",
        text: "La señorita súper amable 🥺 me encantó todo, muchas gracias, nos explicó muy bien la carta ¡Un 10/10!",
    },
    {
        name: "Maria M.M",
        text: "La señorita que nos atendió super amable y atenta. Nos explicó todo sobre los pedidos e ingredientes",
    },
];

export const IG_IMAGES = [
    "https://customer-assets-0z36b82j.emergentagent.net/job_leon-dessert-shop/artifacts/p0m9nozr_6025904769618087233.jpg",
    "https://customer-assets-0z36b82j.emergentagent.net/job_leon-dessert-shop/artifacts/czyt0tqn_6025904769618087232.jpg",
    "https://customer-assets-0z36b82j.emergentagent.net/job_leon-dessert-shop/artifacts/txcim8xv_6025904769618087231.jpg",
    "https://customer-assets-0z36b82j.emergentagent.net/job_leon-dessert-shop/artifacts/k092e23d_6025904769618087234.jpg",
    "https://customer-assets-0z36b82j.emergentagent.net/job_leon-dessert-shop/artifacts/mfmcudv4_6025904769618087230.jpg",
    "https://images.pexels.com/photos/1132558/pexels-photo-1132558.jpeg?auto=compress&cs=tinysrgb&w=600",
];
